import { css } from 'lit'

export default css`
    b {
        font-weight: var(--font-weight-bold);
        color: var(--darkGrey);
    }
`
